import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  imports: [CommonModule],
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) {}
}
